document.addEventListener('change', function (e) {
  const variantInput = e.target.closest(
    'input[name="id"], input[name="options[]"], select[name="id"], select[name^="options"]'
  );

  if (!variantInput) return;

  const scrollPosition = window.scrollY;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: scrollPosition,
        left: 0,
        behavior: 'instant'
      });
    });
  });
});



$(document).ready(function(){
	$('.home-banner-slider').slick({
  dots:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: $('.banner-custom-prev'),
  nextArrow: $('.banner-custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});
	 
});

// Collection Tabbing JS

$(document).ready(function(){
    $(document).on("click",".collection-tab-title",function(){

    var id_tab=$(this).attr("id");
    $(".collection-tab-title").removeClass("active");
    $(this).addClass("active");
    
    $(".tab_body").removeClass("active");
    $(".tab_body#"+id_tab).addClass("active");
  });
});

// Video with text Section JS Start

document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll(".rightVideo");

  videos.forEach(function (video) {
    var playPauseIcon = video.parentElement.querySelector(".playPauseIcon");

    if (!playPauseIcon) return;

    // Click on icon (same behavior as clicking video itself)
    playPauseIcon.addEventListener("click", function () {
      togglePlay(video, playPauseIcon);
    });

    // Click anywhere on video toggles play/pause
    video.addEventListener("click", function () {
      togglePlay(video, playPauseIcon);
    });

    // Keep icon synced with state
    video.addEventListener("pause", function () {
      playPauseIcon.style.display = "flex";
    });

    video.addEventListener("play", function () {
      playPauseIcon.style.display = "none";
    });

    function togglePlay(video, icon) {
      if (video.paused) {
        video.play();
        icon.style.display = "none";
      } else {
        video.pause();
        icon.style.display = "block";
      }
    }
  });
});

  // Video With text Section JS End

  // Tesrimonial Slider JS

$(document).ready(function () {

    var $slider = $('.testimonial-slider');

    $slider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,

        draggable: true,
        swipe: true,
        touchMove: true,

        prevArrow: $(".custom-prev"),
        nextArrow: $(".custom-next"),

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    /* Stop marquee while dragging */
    $slider.on('mousedown touchstart', function () {
        $(this).addClass('is-dragging');
    });

    $slider.on('mouseup touchend mouseleave', function () {
        $(this).removeClass('is-dragging');
    });

});

  // You May also Like Section JS Start

    document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('.custom-you-maylike-area .custom-row .product-item');

    items.forEach(item => {
      item.addEventListener('click', function() {
        // If this item is already selected, remove the class
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
        } else {
          // Otherwise, remove selected from all and add to this one
          items.forEach(i => i.classList.remove('selected'));
          this.classList.add('selected');
        }
      });
    });
  });

  // You May also Like Section JS End

// Js For Adding Class to variant with Image
 
document.addEventListener("DOMContentLoaded", () => {
  const addClassToFieldsets = () => {
    document.querySelectorAll('fieldset.js.product-form__input').forEach(fieldset => {
      if (fieldset.querySelector('label img.variant-picker__image')) {
        fieldset.classList.add('variant-w-img');
      } else {
        fieldset.classList.remove('variant-w-img');
      }
    });
  };
 
  // Run on initial load
  addClassToFieldsets();
 
  // Observe changes to reapply after variant switch
  const observer = new MutationObserver(() => {
    addClassToFieldsets();
  });
 
  observer.observe(document.body, { childList: true, subtree: true });
});

// Jane Bar Slider
$(document).ready(function(){
	$('.jane-bar-carousel').slick({
  dots:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: $('.jane-custom-prev'),
  nextArrow: $('.jane-custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});
	 
});

// Faq Section JS Start

jQuery(".faq-area .accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });



  // Gallery Popop

  document.addEventListener("DOMContentLoaded", () => {
  const imgs = [...document.querySelectorAll(".gallery-img img")];
  if (!imgs.length) return;

  const popup = document.createElement("div");
  popup.className = "gallery-popup";
  popup.innerHTML = `
    <button class="close">&times;</button>
    <span class="prev">&#171;</span>
    <img src="" alt="">
    <span class="next">&#187;</span>
  `;
  document.body.appendChild(popup);

  const imgEl = popup.querySelector("img");
  let current = 0;
  const showImg = i => { imgEl.src = imgs[i].src; popup.classList.add("active"); document.body.style.overflow="hidden"; current=i; };
  const closePopup = () => { popup.classList.remove("active"); document.body.style.overflow=""; };

  imgs.forEach((img, i) => img.addEventListener("click", () => showImg(i)));
  popup.querySelector(".close").onclick = closePopup;
  popup.querySelector(".next").onclick = () => showImg((current + 1) % imgs.length);
  popup.querySelector(".prev").onclick = () => showImg((current - 1 + imgs.length) % imgs.length);
  popup.addEventListener("click", e => { if (e.target === popup) closePopup(); });
});

// Wash Sope Slider
$(document).ready(function(){
	$('.calm-wash-carousel').slick({
  dots:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: $('.calm-custom-prev'),
  nextArrow: $('.calm-custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});
	 
});

// Wash bar tabbing Js

$(document).on("click", ".washbar-benefit-tab-area .benefit-section .tab-btn", function () {
  const section = $(this).closest(".benefit-section");
  section.find(".tab-btn").removeClass("active");
  $(this).addClass("active");

  const target = $(this).data("target");
  section.find(".tab-content.active").fadeOut(200, function () {
    $(this).removeClass("active");
    section.find(target).fadeIn(200).addClass("active");
  });
});


// Bundel Slider
$(document).ready(function(){
	$('.bundel-ing-benefit-carousel').slick({
  dots:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: $('.bundel-custom-prev'),
  nextArrow: $('.bundel-custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});
	 
});


// --------------Menu scroll script

jQuery(function($){
  var $wrap = $('.store-info-area'), 
      $btns = $wrap.find('.tab-btn'), 
      $img = $('#tab-image'), 
      offset = 10;

  if(!$wrap.length || !$btns.length) return;

  function norm(s){ return String(s||'').toLowerCase(); }
  function findBtn(k){ 
    k = norm(k||''); 
    return $btns.filter(function(){ return norm($(this).text()).indexOf(k)!==-1; }).first() || $btns.first(); 
  }
  function openBtn($b, setHash){
    if(!$b.length) return;
    $btns.removeClass('active'); 
    $wrap.find('.tab-content').removeClass('active').addClass('hidden');
    $b.addClass('active'); 
    $('#tab-' + $b.data('tab')).removeClass('hidden').addClass('active');
    if($b.data('image') && $img.length) $img.css('background-image','url('+$b.data('image')+')');
    if(setHash){ 
      var h = $b.attr('data-hash') || ('#'+norm($b.text()).replace(/\s+/g,'_')); 
      history.replaceState && history.replaceState(null,null,h); 
    }
  }

  // Smooth scroll on menu click
  $(document).on('click','#HeaderMenu-experience-locations-showroom,#HeaderMenu-experience-locations-beltline-studio', function(e){
    var href = ($(this).attr('href')||'').replace('#',''), 
        key = href.indexOf('beltline')!==-1 ? 'beltline' : 'showroom';
    if(!href) return;
    e.preventDefault();
    $('html,body').stop().animate(
      { scrollTop: Math.max(0, $wrap.offset().top - offset) },
      800,            // ⏳ slower for smooth scroll (was 300)
      'swing',        // 🌀 smooth easing
      function(){ openBtn(findBtn(key), true); }
    );
  });

  // On page load with hash
  $(window).on('load', function(){
    var h = (location.hash||'').replace('#','').toLowerCase();
    if(!h) return openBtn($btns.first(), false);
    var key = h.indexOf('beltline')!==-1 ? 'beltline' : (h.indexOf('showroom')!==-1 ? 'showroom' : '');
    if(key){ 
      $('html,body').animate({ scrollTop: Math.max(0, $wrap.offset().top - offset) }, 800, 'swing');
      openBtn(findBtn(key), false); 
    }
  });
});








// === Add active class to <span> inside parent menu link ===
document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname.replace(/\/+$/, ''); // remove trailing slash

  // Select all parent <a> inside summary
  const parentLinks = document.querySelectorAll('summary > a.header__menu-item');

  parentLinks.forEach(link => {
    const href = link.getAttribute('href')?.replace(/\/+$/, '');
    if (!href) return;

    // If the current page matches the link
    if (currentPath === href) {
      const span = link.querySelector('span');
      if (span) span.classList.add('header__active-menu-item');
    }
  });
});




// Wash Sope Slider
$(document).ready(function(){
    $('.gallery_slider').slick({
    dots:false,
    infinite: true,
      autoplay: true,
  autoplaySpeed: 0,
  speed: 9000,
  cssEase: 'linear',
  pauseOnHover: true,
  pauseOnFocus: true,
  draggable: true,
  swipe: false,
  touchMove: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.calm-custom-prev'),
    nextArrow: $('.calm-custom-next'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      
    ]
  });
	 
});

$(document).ready(function () {

    var $slider = $('.testimonial-slider');

    $slider.slick({
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,

        draggable: true,
        swipe: true,
        touchMove: true,

        prevArrow: $(".custom-prev"),
        nextArrow: $(".custom-next"),

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    /* Stop marquee while dragging */
    $slider.on('mousedown touchstart', function () {
        $(this).addClass('is-dragging');
    });

    $slider.on('mouseup touchend mouseleave', function () {
        $(this).removeClass('is-dragging');
    });

});



// Compact & robust gallery lightbox
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.gallery_slider');
  if (!container) { console.warn('Gallery container .gallery_slider not found'); return; }

  // create popup once
  const popup = document.createElement('div');
  popup.className = 'gpop';
  popup.innerHTML = `
    <div class="inner" role="dialog" aria-modal="true">
      <button class="gallery_btn gallery_close" aria-label="Close">&times;</button>
      <button class="gallery_btn gallery_prev" aria-label="Prev">&#8249;&#8249;</button>
      <img class="gallery_img" src="" alt="">
      <button class="gallery_btn gallery_next" aria-label="Next">&#8250;&#8250;</button>
    </div>
  `;
  document.body.appendChild(popup);

  const imgEl = popup.querySelector('.gallery_img');
  const closeBtn = popup.querySelector('.gallery_close');
  const nextBtn = popup.querySelector('.gallery_next');
  const prevBtn = popup.querySelector('.gallery_prev');
  let srcs = [];
  let idx = 0;
  let built = false;

  // build list of unique srcs in DOM order (call once when first opening)
  function buildSrcs() {
    const thumbs = Array.from(document.querySelectorAll('.gallery_slider .left-image'));
    const map = new Map();
    thumbs.forEach(t => {
      const s = t.currentSrc || t.src || t.getAttribute('src');
      if (s) map.set(s, s);
    });
    srcs = Array.from(map.keys());
    built = true;
  }

  function openAt(n) {
    if (!built) buildSrcs();
    if (!srcs.length) return console.warn('No images found for lightbox');
    idx = ((n % srcs.length) + srcs.length) % srcs.length;
    imgEl.src = srcs[idx];
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    // preload neighbors
    [srcs[(idx+1)%srcs.length], srcs[(idx-1+srcs.length)%srcs.length]].forEach(s=>{const i=new Image(); i.src=s;});
  }

  function close() {
    popup.classList.remove('active');
    document.body.style.overflow = '';
    imgEl.src = '';
  }

  // delegation: open when any .left-image inside .gallery_slider is clicked
  container.addEventListener('click', (e) => {
    const t = e.target.closest('img.left-image');
    if (!t) return;
    const s = t.currentSrc || t.src || t.getAttribute('src');
    if (!s) return;
    if (!built) buildSrcs();
    const i = srcs.indexOf(s);
    if (i === -1) { console.warn('Clicked image src not found in list'); buildSrcs(); openAt(srcs.indexOf(s)); }
    else openAt(i);
  });

  // controls
  popup.addEventListener('click', (e) => {
    // click outside image closes
    if (e.target === popup) close();
  });
  closeBtn.addEventListener('click', close);
  nextBtn.addEventListener('click', () => openAt(idx + 1));
  prevBtn.addEventListener('click', () => openAt(idx - 1));

  // keyboard
  document.addEventListener('keydown', (e) => {
    if (!popup.classList.contains('active')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') openAt(idx + 1);
    if (e.key === 'ArrowLeft') openAt(idx - 1);
  });
});


// Varient INGREDIENT Change JS Start



// Varient INGREDIENT Change JS End
  // $(document).on('click', '.header__icon.header__icon--help', function (e) {
   
  //   e.preventDefault();
  //     $('#shopify-chat .chat-toggle').trigger("click");
  // });
  $(document).on('click', '.header__icon.header__icon--help', function () {
      if (window.ShopifyInbox) {
          window.ShopifyInbox.open();
      } else {
          console.warn("Shopify Inbox not loaded yet");
      }
  });
  document.addEventListener("DOMContentLoaded", function() {
    const btn = document.querySelector(".header__icon--help");
    if (btn) {
        btn.addEventListener("click", function(e) {
            e.preventDefault();

            // Replace this with the Infox popup trigger
            if (window.InfoxPopup) {
                window.InfoxPopup.open();
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#chat"]');
    if (!link) return;

    // Verify the href specifically targets the #chat hash
    const url = new URL(link.href, window.location.href);
    if (url.hash === '#chat') {
      event.preventDefault();

      const chatElement = document.querySelector('shopify-chat');

      // 1. Primary: Try native ShopifyChat API
      if (window.ShopifyChat?.open) {
        window.ShopifyChat.open();
        return;
      }

      // 2. Direct attribute manipulation
      if (chatElement) {
        chatElement.setAttribute('open', '');
        chatElement.setAttribute('shell-ready', '');
        return;
      }

      // 3. Fallback: Emulate click on embedded trigger if available
      const trigger = document.querySelector('[data-shopify-chat-trigger]');
      if (trigger) trigger.click();
    }
  });
});